var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1768647778655,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 31547,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M924 63.9H122.3C90.1 63.9 64 90 64 122.2v806.1c0 17.2 14.1 31.3 31.3 31.3 17.2 0 31.3-14.1 31.3-31.3v-80.7c0-12.4 10-22.4 22.4-22.4h725.4c12.4 0 22.4 10 22.4 22.4v80.6c0 17.2 14.1 31.3 31.3 31.3 17.2 0 31.3-14.1 31.3-31.3V99.7c0.3-19.8-15.7-35.8-35.4-35.8zM126.9 740V601.2c0-12.4 10-22.4 22.4-22.4h284.1c17.2 0 31.3-14.1 31.3-31.3 0-17.2-14.1-31.3-31.3-31.3H149.3c-12.4 0-22.4-10-22.4-22.4V372.9c0-12.4 10-22.4 22.4-22.4h221.5c17.2 0 31.3-14.1 31.3-31.3 0-17.2-14.1-31.3-31.3-31.3H149.3c-12.4 0-22.4-10-22.4-22.4V148.9c0-12.4 10-22.4 22.4-22.4h725.4c12.4 0 22.4 10 22.4 22.4V740c0 12.4-10 22.4-22.4 22.4H149.3c-12.4 0-22.4-10-22.4-22.4z",
    "p-id": 31548,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M670.2 251.9c18.4 0 33.3 14.8 33.3 33.2v249.3L750 488c13-13 34.1-13 47 0 6.4 6.4 9.8 15.1 9.8 23.4 0 8.3-3.4 17-9.8 23.4l-103.3 103c-6.4 6.4-15.1 9.8-23.5 9.8-0.9 0-1.7 0-2.6-0.2h-0.4c-8.9-0.9-16.6-5.1-22-11.3L543.7 534.8c-13-13-13-34 0-46.8 13-13 34.1-13 47 0l46.3 46.2V285.3c-0.1-18.4 14.8-33.4 33.2-33.4z",
    "p-id": 31549,
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicking);
export default __webpack_public_path__ + "static/media/picking.7c3477d3a9aa42d0755df2ef4a747066.svg";
export { ForwardRef as ReactComponent };